import {Apis} from "./url";
import {ShowSnackbar} from "../template/snackbar";
import {HideProgressLoading} from "../template/architecture";

export const AuthRedirectAdmins = () =>{
    window.location.href = '/signin/admin?then=' + encodeURIComponent(window.location.toString());
};

export const AuthRedirectParents = () =>{
    window.location.href = '/signin?then=' + encodeURIComponent(window.location.toString());
};

export const AuthRedirectHr = () =>{
    window.location.href = '/signin/hr?then=' + encodeURIComponent(window.location.toString());
};

export const AuthRedirectSignup = () =>{
    window.location.href = '/signup/login?then=' + encodeURIComponent(window.location.toString());
};

const PreAuthCheck = (panelMode:'admins'|'parents'|'hr'|'signup') : {tk:string,verified:boolean} => {
    let token = localStorage.getItem(panelMode === 'admins' ? 'myAuth' : (panelMode === 'hr' ? 'hrAuth' : (panelMode === 'parents' ? 'parentAuth' : 'signupAuth')));
    if(token === null || token === '')
        return {tk:'',verified:false};
    return {tk:token,verified:true};
};

export const PostJSON = async (url:string,data:any,auth:boolean,onComplete:any,onError:any,onAuthFail:any,panelMode:'admins'|'parents'|'hr'|'signup'='admins') => {
    let dataURLEncoded = [];
    if (auth){
        const s = PreAuthCheck(panelMode);
        if (!s.verified){
            onAuthFail();
            return;
        }
        dataURLEncoded.push("_tk="+s.tk);
    }
    for(let p in data)
        dataURLEncoded.push(encodeURIComponent(p)+"="+encodeURIComponent(data[p]));

    const dataString = dataURLEncoded.join('&');
    try{
        await fetch(
            url,
            {
                method:'POST',
                headers:new Headers({'Content-Type':'application/x-www-form-urlencoded'}),
                body:dataString,
            })
            .then(res => res.json())
            .then((response)=>onComplete(response),()=> {
                ShowSnackbar(
                    'ارتباط با سرور برقرار نشد.',
                    'باشه',
                    5000,
                );
                HideProgressLoading();
            }).catch(()=>{
                ShowSnackbar(
                    'ارتباط با سرور برقرار نشد.',
                    'باشه',
                    5000,
                );
                HideProgressLoading();
            });
    } catch (e){
        ShowSnackbar(
            'ارتباط با سرور برقرار نشد.',
            'باشه',
            5000,
        );
        HideProgressLoading();
    }
};

export const TecharanSvg = (id:string) => {
    return Apis.server + "/svg/" + id;
};

export const ServerImage = (file:string,width:number|0=0,height:number|0=0) => {
    return Apis.server + `/image/${file}/${width}/${height}`
};

export const PostUploadJSON = async (url:string,data:any,auth:boolean,onComplete:any,onError:any,onAuthFail:any,panelMode:'admins'|'parents'|'hr'|'signup'='admins') => {
    let formData = new FormData();
    if (auth){
        const s = PreAuthCheck(panelMode);
        if (!s.verified){
            onAuthFail();
            return;
        }
        formData.set("_tk",s.tk);
    }
    for(let p in data)
        formData.append(p,data[p]);
    fetch(
        url,
        {
            method:'POST',
            body:formData,
        },
    )
        .then(res => res.json())
        .then(response => onComplete(response), onError);
};